import { useCallback } from 'react';

const validate = (cred) => {
  const errors = {};

  if (!cred?.data?.number?.credential_number) {
    errors.credential_number = 'Credential number is required';
  }
  if (!cred?.issued_at) {
    errors.issued_at = 'Issued date is required';
  }
  if (!cred?.expired_at) {
    errors.expired_at = 'Expiration date is required';
  }

  return errors;
};

const hasFieldChanged = (current, original, field) => {
  if (field === 'credential_number') {
    return (current?.data?.number?.credential_number ?? '') !== (original?.data?.number?.credential_number ?? '');
  }
  return (current?.[field] ?? '') !== (original?.[field] ?? '');
};

export const useCredentialNumber = () => {
  const getErrors = useCallback((current, original) => {
    const allErrors = validate(current);
    const visibleErrors = {};
    Object.entries(allErrors).forEach(([field, message]) => {
      if (hasFieldChanged(current, original, field)) {
        visibleErrors[field] = message;
      }
    });
    return visibleErrors;
  }, []);

  const validateAll = useCallback((credentials) => {
    const allErrors = {};

    credentials.forEach((cred) => {
      const credErrors = validate(cred);
      if (Object.keys(credErrors).length > 0) {
        allErrors[cred.id || cred.credential] = credErrors;
      }
    });

    return allErrors;
  }, []);

  return { getErrors, validateAll };
};
